import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=10d6406a&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"
import style0 from "./NavBar.vue?vue&type=style&index=0&id=10d6406a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d6406a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Layout: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/Layout.vue').default,SvgRender: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/SvgRender.vue').default,ImgRender: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/ImgRender.vue').default,Selector: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/Selector.vue').default,SvgRenderMenu: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/SvgRenderMenu.vue').default,Link: require('C:/4Team_Git/FT.Web.Products/FT.Web.Templated/components/Link.vue').default})
